import { BACKEND_PUBLIC } from '../base'

export async function getSkills () {
  return BACKEND_PUBLIC.get<LX.Skill[]>('/skills/list')
}
